import React from 'react';
import T from 'prop-types';
import { compact, isArray, isEmpty } from 'lodash-es';

import Tooltip from '../../../../components/Tooltip';

const KpiTrackingIndicator = ({ correlationStatus, kpis, hideTooltip = false }) => {
  const kpiList = isArray(kpis) ? compact(kpis) : [];

  if (!['high', 'medium'].includes(correlationStatus?.toLowerCase()) || isEmpty(kpiList))
    return null;

  const tooltipContent = (
    <div className="data-strength-indicator-tooltip__content">
      <div className="data-strength-indicator-tooltip__header">
        <h5 className="h5">Reported KPIs our app data tracks</h5>
        <p>Based on the correlation between Apptopia app data and company-reported KPIs.</p>
      </div>
      <ul className="data-strength-indicator-tooltip__kpis">
        {kpiList.map(({ va_kpi_id, va_kpi_name }) => (
          <li key={va_kpi_id}>{va_kpi_name}</li>
        ))}
      </ul>
    </div>
  );

  return (
    <Tooltip
      content={!hideTooltip ? tooltipContent : null}
      placement="bottomLeft"
      colorVariant="light"
      overlayClassName="data-strength-indicator-tooltip ignore-onclickoutside"
    >
      <div className="data-strength-indicator medium cursor-default">Tracks Reported KPIs</div>
    </Tooltip>
  );
};

KpiTrackingIndicator.propTypes = {
  correlationStatus: T.string,
  kpis: T.arrayOf(T.shape({ va_kpi_id: T.number, va_kpi_name: T.string })),
  hideTooltip: T.bool,
};

export default KpiTrackingIndicator;
